import dayjs from 'dayjs';
import { getDateFormat } from './getDateFormat';

export function dateToApiaFormat(date: string | Date) {
  return dayjs(date).format(getDateFormat());
}
